







import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Dashboard from '../organisms/Dashboard.vue'
import MyExamList from './ExamMyList.vue'
import { headerState } from '../../stores/header'

@Component({
  components: {
    Dashboard,
    MyExamList
  }
})
export default class Home extends Vue {
  get schoolSetting(){
    return headerState.schoolSetting
  }
}
